import React from 'react';
import { withRouter } from 'react-router-dom';
import FieldModal from '../../../../components/modals/fieldModal';

const FIELD_OPTIONS = [
	{ value: 'name', label: 'Name' },
	{ value: 'category', label: 'Category' },
	{ value: 'vendor', label: 'Vendor' },
	{ value: 'referenceNumber', label: 'Reference Number' },
	{ value: 'trackingNumber', label: 'Tracking Number' },
];

class IdentifyDuplicatesModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 'select',
			selectedField: 'name',
			duplicateGroups: [],
			keepSelections: {},
			submitting: false
		};
	}

	findDuplicates = () => {
		const { inventory } = this.props;
		const { selectedField } = this.state;

		const groups = {};
		inventory.forEach((item) => {
			const val = item[selectedField];
			if (val === undefined || val === null || val === '') return;
			const key = val.toString().trim().toLowerCase();
			if (!groups[key]) groups[key] = [];
			groups[key].push(item);
		});

		const duplicateGroups = Object.entries(groups)
			.filter(([, items]) => items.length >= 2)
			.map(([key, items]) => ({ key, items }));

		const keepSelections = {};
		duplicateGroups.forEach((group, i) => {
			keepSelections[i] = group.items[0]._id;
		});

		this.setState({ duplicateGroups, keepSelections, step: 'review' });
	};

	handleKeepChange = (groupIndex, itemId) => {
		this.setState((prev) => ({
			keepSelections: { ...prev.keepSelections, [groupIndex]: itemId }
		}));
	};

	getItemsToDelete = () => {
		const { duplicateGroups, keepSelections } = this.state;
		const toDelete = [];
		duplicateGroups.forEach((group, i) => {
			group.items.forEach((item) => {
				if (item._id !== keepSelections[i]) {
					toDelete.push(item._id);
				}
			});
		});
		return toDelete;
	};

	handleRemoveDuplicates = () => {
		const { toggle, deleteInventoriesByIds } = this.props;
		const toDelete = this.getItemsToDelete();
		if (!toDelete.length) return;
		this.setState({ submitting: true });
		deleteInventoriesByIds(toDelete, () => {
			this.setState({ submitting: false, step: 'select', duplicateGroups: [], keepSelections: {} });
			toggle();
		});
	};

	backToSelect = () => {
		this.setState({ step: 'select', duplicateGroups: [], keepSelections: {} });
	};

	renderSelectStep = () => {
		const { toggle } = this.props;
		const { selectedField } = this.state;

		return (
			<FieldModal
				size="small"
				isOpen={true}
				modalTitle="Identify Duplicates"
				bodyHeaderText="Select a field to scan for duplicate inventory items."
				bodyContent={() => (
					<div style={{ padding: '8px 0' }}>
						<label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 13 }}>
							Match duplicates by:
						</label>
						<select
							className="w-100"
							value={selectedField}
							onChange={(e) => this.setState({ selectedField: e.target.value })}
							style={{
								padding: '8px 10px',
								borderRadius: 4,
								border: '1px solid #ccc',
								fontSize: 14,
								width: '100%',
								background: '#fff'
							}}
						>
							{FIELD_OPTIONS.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))}
						</select>
					</div>
				)}
				toggle={toggle}
				actionButtonLabel="Find Duplicates"
				actionButton={this.findDuplicates}
				actionButtonDisabled={false}
			/>
		);
	};

	renderReviewStep = () => {
		const { toggle } = this.props;
		const { duplicateGroups, keepSelections, submitting, selectedField } = this.state;
		const toDeleteCount = this.getItemsToDelete().length;
		const fieldLabel = FIELD_OPTIONS.find((o) => o.value === selectedField)?.label || selectedField;

		return (
			<FieldModal
				size="large"
				className="identify-duplicates-modal"
				isOpen={true}
				modalTitle="Identify Duplicates"
				bodyHeaderText={
					<span>
						Found <b>{duplicateGroups.length}</b> duplicate group{duplicateGroups.length !== 1 ? 's' : ''}.
						Select which item to <b>keep</b> in each group — all others will be removed.
					</span>
				}
				bodyContent={() => (
					<div style={{ maxHeight: 420, overflowY: 'auto', paddingRight: 4 }}>
						{duplicateGroups.map((group, groupIndex) => (
							<div
								key={groupIndex}
								style={{
									border: '1px solid #e0e0e0',
									borderRadius: 6,
									marginBottom: 16,
									overflow: 'hidden'
								}}
							>
								<div
									style={{
										background: '#f5f5f5',
										padding: '8px 14px',
										fontWeight: 600,
										fontSize: 13,
										borderBottom: '1px solid #e0e0e0'
									}}
								>
									{fieldLabel}: &ldquo;{group.items[0][selectedField]}&rdquo; &mdash;{' '}
									{group.items.length} matches
								</div>
								<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
									<thead>
										<tr style={{ background: '#fafafa', borderBottom: '1px solid #e0e0e0' }}>
											<th style={{ padding: '6px 10px', width: 40 }}></th>
											<th style={{ padding: '6px 10px', textAlign: 'left' }}>Name</th>
											<th style={{ padding: '6px 10px', textAlign: 'left' }}>Vendor</th>
											<th style={{ padding: '6px 10px', textAlign: 'right' }}>Redeemed</th>
											<th style={{ padding: '6px 10px', textAlign: 'right' }}>Booked</th>
											<th style={{ padding: '6px 10px', textAlign: 'right' }}>Qty</th>
											<th style={{ padding: '6px 10px', textAlign: 'right' }}>Price</th>
											<th style={{ padding: '6px 10px', textAlign: 'left' }}>Status</th>
											<th style={{ padding: '6px 10px', width: 60 }}></th>
										</tr>
									</thead>
									<tbody>
										{group.items.map((item) => {
											const isKept = keepSelections[groupIndex] === item._id;
											return (
												<tr
													key={item._id}
													style={{
														background: isKept ? 'rgba(43, 131, 241, 0.062745098)' : '#fff',
														color: 'inherit',
														borderBottom: '1px solid #f0f0f0',
														transition: 'background 0.15s'
													}}
												>
													<td style={{ padding: '8px 10px', textAlign: 'center' }}>
														<input
															type="radio"
															name={`keep-group-${groupIndex}`}
															checked={isKept}
															onChange={() => this.handleKeepChange(groupIndex, item._id)}
															style={{ cursor: 'pointer' }}
														/>
													</td>
													<td style={{ padding: '8px 10px' }}>{item.name || '—'}</td>
													<td style={{ padding: '8px 10px' }}>{item.vendor || '—'}</td>
													<td style={{ padding: '8px 10px', textAlign: 'right' }}>{item.redeemedByCount ?? '—'}</td>
													<td style={{ padding: '8px 10px', textAlign: 'right' }}>{item.bookedByCount ?? '—'}</td>
													<td style={{ padding: '8px 10px', textAlign: 'right' }}>{item.quantity ?? '—'}</td>
													<td style={{ padding: '8px 10px', textAlign: 'right' }}>
														{item.price != null ? `$${Number(item.price).toFixed(2)}` : '—'}
													</td>
													<td style={{ padding: '8px 10px' }}>{item.status || '—'}</td>
													<td style={{ padding: '8px 10px', textAlign: 'center' }}>
														{isKept && (
															<span
																style={{
																	background: 'var(--primary)',
																	color: '#fff',
																	borderRadius: 10,
																	padding: '2px 8px',
																	fontSize: 11,
																	fontWeight: 700,
																	letterSpacing: 0.3
																}}
															>
																Keep
															</span>
														)}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						))}
					</div>
				)}
				toggle={toggle}
				cancelButtonLabel="Back"
				cancelOnClick={this.backToSelect}
				actionButtonLabel={
					submitting
						? 'Removing...'
						: `Remove duplicates (${toDeleteCount} item${toDeleteCount !== 1 ? 's' : ''})`
				}
				actionButton={this.handleRemoveDuplicates}
				actionButtonDisabled={submitting || toDeleteCount === 0}
				isDelete={true}
			/>
		);
	};

	render() {
		const { step } = this.state;
		return (
			<div>
				{step === 'select' ? this.renderSelectStep() : this.renderReviewStep()}
			</div>
		);
	}
}

export default withRouter(IdentifyDuplicatesModal);
